import { useEffect, useState } from "react";
import { api } from "../api";
import type { CommuteHistoryResponse } from "../types";
import { today } from "../payrollPresentation";
import { commuteClock, commuteMonthRange } from "../commuteHistoryPresentation";
import { Field, Input } from "./ui/Field";
import { Button } from "./ui/Button";
import { EmptyState, Feedback, TableFrame } from "./ui/Surface";
import { Select } from "./Select";
import "./CommuteHistory.css";

export function CommuteHistory() {
  const [month, setMonth] = useState(() => today().slice(0, 7));
  const [worker, setWorker] = useState("");
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState<{ key: string; data?: CommuteHistoryResponse; error?: string }>({ key: "" });
  const range = commuteMonthRange(month), key = `${month}:${revision}`;
  useEffect(() => {
    if (!range) return;
    const controller = new AbortController();
    void api.commuteHistory(range, controller.signal).then(data => {
      if (!controller.signal.aborted) setState({ key, data });
    }).catch(cause => {
      if (!controller.signal.aborted) setState({ key, error: cause instanceof Error ? cause.message : "출퇴근 기록을 불러오지 못했습니다." });
    });
    return () => controller.abort();
  }, [key]);
  const data = state.key === key ? state.data : undefined;
  const error = state.key === key ? state.error : undefined;
  const names = [...new Set([...(data?.workerNames ?? []), ...(worker ? [worker] : [])])].sort((a, b) => a.localeCompare(b, "ko"));
  const rows = data?.records.filter(row => !worker || row.workerName === worker) ?? [];
  return <div className="commute-history" data-testid="commute-history">
    <div className="commute-history-filters">
      <Field label="조회 월"><Input type="month" value={month} onChange={event => setMonth(event.target.value)} data-testid="commute-history-month" /></Field>
      <Field label="작업자"><Select searchable value={worker} aria-label="출퇴근 작업자" onChange={event => setWorker(event.target.value)}>
        <option value="">전체 작업자</option>{names.map(name => <option key={name} value={name}>{name}</option>)}
      </Select></Field>
      <Button disabled={!range} onClick={() => setRevision(value => value + 1)}>새로고침</Button>
    </div>
    {!range ? <Feedback>조회할 월을 선택해 주세요.</Feedback>
      : error ? <Feedback tone="error">{error} <Button onClick={() => setRevision(value => value + 1)}>다시 시도</Button></Feedback>
      : !data ? <p role="status">출퇴근 기록을 불러오고 있습니다…</p>
      : !rows.length ? <EmptyState>조회한 조건의 출퇴근 기록이 없습니다.</EmptyState>
      : <TableFrame label="작업자별 날짜별 출퇴근 기록" className="commute-history-table">
        <thead><tr><th scope="col">날짜</th><th scope="col">작업자</th><th scope="col">출근</th><th scope="col">퇴근</th></tr></thead>
        <tbody>{rows.map(row => <tr key={`${row.date}:${row.workerName}`}>
          <td>{row.date}</td><th scope="row">{row.workerName}</th><td>{commuteClock(row.arrivalTime)}</td><td>{commuteClock(row.departureTime)}</td>
        </tr>)}</tbody>
      </TableFrame>}
  </div>;
}
